import { createGLBModel } from "./GLBModel";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

import fishUrl from "../../../../assets/models/BarramundiFish.glb";

const BarramundiFishModel = createGLBModel({
  id: "barramundi-fish",

  name: "Barramundi Fish",

  url: fishUrl,

  transform: {
    position: [0, 0, 0],

    rotation: [0, 0, 0],

    scale: 10.0,
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },

  geometryProcessor: computeCurvatureDirections,
});

export default BarramundiFishModel;
